import { render, staticRenderFns } from "./OrderStatusAutocomplete.vue?vue&type=template&id=6dd15ba6"
import script from "./OrderStatusAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./OrderStatusAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports